import { Center, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { LIST_MAX_HEIGHT } from '~/components/ShiftRequestRedesign/AddInvites/EmbeddedInviteList/TabContent';
import { CalendarTodayFilterIcon } from '~/images/emptyScreenIcons';

/** Empty state for the Interview Details candidate list — sized to match the list. */
export const CandidatesEmpty = () => (
  <Center height={`${LIST_MAX_HEIGHT}px`}>
    <Column align="center" gap={3} px={6}>
      <CalendarTodayFilterIcon />
      <Typography variant="subtitle1" bold color={colors.neutral[600]} textAlign="center">
        No candidates available at this time!
      </Typography>
      <Typography variant="body1" color={colors.neutral[500]} textAlign="center">
        It looks like you don’t have any candidates for this job yet! Once a professional applies,
        they will appear on here where you will be able send direct invites to upcoming interviews.
      </Typography>
    </Column>
  </Center>
);
